.is-building-view {
    z-index: 12;
    position: absolute;
    text-align: center;
    align-items: center;
    top: 50px;
    width: 100%;
    background-color: white;
}
